import { FormGroup } from "@angular/forms";
import { FormlyView } from "../FormlyView";
import { FieldDefinition } from "../../../../sections/webtrader/webtrader/message/fieldDefinition";

export class XEVPRMImportedAck extends FormlyView
{

    constructor(
        form: FormGroup,
        fieldDefinition: FieldDefinition,
        model: {},
    ) {
        super(form, [...fieldDefinition.messageHeaderFields], model);
    }
    
}